import {workplaceTypes} from "../types";
import {ModalContainerWarningRemovePhoto} from "../Modal/ModalContainerWarningRemovePhoto";
import {addCommentPhoto, paintPhoto, removeElementIndexedDB, savePhotoDB, unixTimeToDate} from "../functions";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';
import { flightMenuBlock } from '@/Block/FlightMenuBlock.js';


export var TaskFlightPhotoPage = {
    controller: function () {
        var self = this;

        if (!user.exists()) {
            m.route('/login');
            return;
        }

        interval.clearAll();

        loader.show();

        if (user.get('state.workplace') === workplaceTypes.driver) {
            this.topMenu = [
                { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];

            if (user.get('state.vehicleFreeTasksAvailable')) {
                this.topMenu.unshift(
                    { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
                )
            }
        } else if (user.get('state.workplace') === workplaceTypes.agent) {
            this.topMenu = [
                { title: 'Задачи', url: '/agent/tasks', icon: 'fa-tasks' },
                { title: 'Рейсы', url: '/agent/flights', icon: 'fa-plane' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        } else {
            this.topMenu = [
                { title: 'Задачи', url: '/', icon: 'fa-tasks' },
                { title: 'Профиль', url: '/profile', icon: 'fa-user' },
                isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
                { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
            ];
        }

        this.data = m.request({
            method: 'GET',
            url: '/api/task/' + m.route.param('taskId') + '/photo'
        }).then(function (response) {
            server.setOnline();
            loader.hide();
            storage.config = response.config;

            appNotification.list = response.notifications;

            server.initPing();
            appNotification.init();

            let unsavedPhoto = localStorage.getItem("unsavedPhoto");
            if (unsavedPhoto)
                unsavedPhoto = JSON.parse(unsavedPhoto);
            else
                unsavedPhoto = [];

            response.unsavedPhoto = unsavedPhoto;

            return response;
        }, function (response) {
            if (response && response.message) {
                self.errmsg = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: ctrl.data().time,
                menu: ctrl.topMenu
            }),
            m("div[style='margin-top:0px']", [
                VehicleNumberBlock(),
                m.component(flightMenuBlock, {
                    board: ctrl.data().board,
                    menu: ctrl.data().menu,
                    tasks: ctrl.data().tasks,
                    currentTask: ctrl.data().currentTask,
                    tab: 'info'
                })
            ]),
            m("div[style='padding: 0 15px; padding-top: 10px;']", [

                ctrl.errmsg,
                m("div[id='pictureConteiner'][style='width: 100%; height: auto; margin: 0']", [
                    ctrl.data().unsavedPhoto.map(function (elem) {
                        return m("div", {
                            id: elem.name,
                            style: 'display: flex; flex-direction: column; align-items: center; margin-top: 7px; outline: 1px solid #000;'
                        }, [
                            m("div", {
                                className: "row bg-info",
                                style: "padding:6px;padding-right: 11px;z-index:1; width: 100%;"
                            }, [
                                m("span", {
                                    className: "pull-right",
                                    style: "cursor: pointer;",
                                    innerHTML: "<i class='glyphicon glyphicon-remove'>&nbsp;Удалить",
                                    onclick: function () {
                                        ModalContainerWarningRemovePhoto.open("Вы действительно хотите удалить фото?", false, false, elem.name);
                                    }
                                })
                            ]),
                            m("img", {
                                src: elem.blobUrl,
                                name: elem.name,
                                className: "col-xs-12 col-sm-6 col-md-4 col-xl img-thumbnail",
                                onerror: function () {
                                    removeElementIndexedDB(elem.name);
                                }
                            }),
                            m("textarea", {
                                rows: 3,
                                placeholder: "Комментарий",
                                style: "margin: 0px 7px; width: 100%;",
                                value: (elem.comment != "") ? elem.comment : '',
                                onfocus: function () {
                                    let el = document.getElementsByClassName("fixButton")["buttonCamera"];
                                    el.classList.add("disapear");
                                },
                                onblur: function () {
                                    let el = document.getElementsByClassName("fixButton")["buttonCamera"];
                                    el.classList.remove("disapear");
                                    addCommentPhoto(elem.name, this.value);
                                }
                            })
                        ])
                    }),
                ]),

                m("div[style='position: relative; text-align:center;']", [
                    m("div[style='display:inline-block;']", [
                        m("div.fixButton.btn.bg-info[id='buttonCamera']", {
                            onclick: function () {
                                document.getElementById("cameraFileInput").addEventListener("change", function () {
                                    var name = /*ctrl.data().info.NR + "_" + */unixTimeToDate(this.files[0].lastModified);
                                    var dateTime = unixTimeToDate(this.files[0].lastModified);
                                    var size = this.files[0].size / 1000000;
                                    var photoUrl = window.URL.createObjectURL(this.files[0]);

                                    let unsavedPhoto = localStorage.getItem("unsavedPhoto");
                                    if (unsavedPhoto) {
                                        unsavedPhoto = JSON.parse(unsavedPhoto);
                                        for (let i = 0; i < unsavedPhoto.length; i++) {
                                            if(unsavedPhoto[i].name == name) {
                                                return;
                                            }
                                        }
                                    }
                                    else
                                        unsavedPhoto = [];

                                    unsavedPhoto.push({ "name": name, "dk": dateTime, "comment": '', "blobUrl": photoUrl });

                                    let value = JSON.stringify(unsavedPhoto);

                                    localStorage.setItem("unsavedPhoto", value);
                                    paintPhoto();

                                    var base64Photo = "";
                                });
                                const input = document.getElementById('cameraFileInput');
                                input.focus();
                                input.click();
                            },
                        }, [
                            m("i.fa.fa-2x.fa-camera[aria-hidden='true']")
                        ])
                    ])
                ]),

                m("input[id='cameraFileInput'][type='file'][accept='image/*'][capture='environment']"),

                m("div[style='margin: 4px']", [
                    m("div.btn-group.btn-group-lg.btn-group-justified[role='group'][style='margin-top: 10px;']", [
                        m("div.btn.btn-success[style='border-radius: 15px;']", {
                            onclick: function () {
                                savePhotoDB();
                            }
                        }, "Сохранить"),
                        m("div.btn.btn-danger[style='border-radius: 15px;']", {
                            onclick: function () {
                                ModalContainerWarningRemovePhoto.open("Вы действительно хотите удалить все фото?", true, false);
                            }
                        }, "Сброс"),
                    ]),
                ]),

                ModalContainerWarningRemovePhoto.init()
            ])
        ]
    }
};
